import * as angular from 'angular';
import LibraryProcessMapsGridBridge from './LibraryProcessMapsGridBridge';

angular
  .module('flowingly.runner.library')
  .component('libraryProcessMapsGrid', LibraryProcessMapsGridBridge);
